import { useSiteKnowledge } from "@/lib/siteKnowledge";

export default function AboutFaqSection() {
  const { knowledge } = useSiteKnowledge();
  const faqs = (knowledge.faqs || []).filter((row) => {
    if (row.enabled === false || !row.question || !row.answer) return false;
    const surfaces = row.surfaces;
    if (!surfaces || !surfaces.length) return true;
    return surfaces.includes("about");
  });
  if (!faqs.length) return null;

  return (
    <section id="faq" data-testid="about-faq-section" className="px-6 md:px-12 py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-3">FAQ</p>
        <h2 className="font-display text-3xl md:text-4xl text-slate-900 mb-8">자주 묻는 질문</h2>
        <div className="space-y-4">
          {faqs.map((row) => (
            <article key={row.id} className="border border-slate-200 rounded-2xl p-5" data-testid={`about-faq-${row.id}`}>
              <h3 className="text-base font-medium text-slate-900">{row.question}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed whitespace-pre-line">{row.answer}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
